import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/copy.svg'
import _imports_1 from '../assets/close-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-6f63eae5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-square" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "icon-container"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "project-display",
      onClick: _cache[0] || (_cache[0] = () => _ctx.openWorkspace()),
      innerHTML: _ctx.name.replaceAll('_', '_<wbr>')
    }, null, 8, _hoisted_2),
    (_ctx.isEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "icon-button blue",
            onClick: _cache[1] || (_cache[1] = () => _ctx.onDuplicate()),
            disabled: !_ctx.canCreate
          }, _hoisted_6, 8, _hoisted_4),
          _createElementVNode("button", {
            class: "icon-button red",
            onClick: _cache[2] || (_cache[2] = () => _ctx.onDelete())
          }, _hoisted_8)
        ]))
      : _createCommentVNode("", true)
  ]))
}